import { __decorate, __extends } from "tslib";
import { proxyTo } from '../utils/FilterUtils';
import { FilterBase } from './FilterBase';
import { DisplacementTask } from './tasks/DisplacementTask';
var DisplacementFilter = /** @class */ (function (_super) {
    __extends(DisplacementFilter, _super);
    function DisplacementFilter(props) {
        var _this = _super.call(this) || this;
        _this._displacement = new DisplacementTask();
        _this.addTask(_this._displacement);
        _this.applyProps(props);
        return _this;
    }
    DisplacementFilter.prototype.applyProps = function (props) {
        if (!props)
            return;
        // run all model field that changed
        for (var key in props) {
            this[key] = props[key];
        }
    };
    DisplacementFilter.filterName = 'displacement';
    __decorate([
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "mapBitmap", void 0);
    __decorate([
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "mapPoint", void 0);
    __decorate([
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "componentX", void 0);
    __decorate([
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "componentY", void 0);
    __decorate([
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "scaleX", void 0);
    __decorate([
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "scaleY", void 0);
    __decorate([
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "mode", void 0);
    __decorate([
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "color", void 0);
    __decorate([
        proxyTo('_displacement')
    ], DisplacementFilter.prototype, "alpha", void 0);
    return DisplacementFilter;
}(FilterBase));
export { DisplacementFilter };
